import { Vector3 } from './vector-utils';
function kptToZup(kpt) {
    return [-kpt.z, -kpt.x, kpt.y];
}
function findKeys(part) {
    if (part === 'hip') {
        return {
            p0: 'left_hip',
            p1: 'right_hip',
        };
    }
    if (part === 'torso') {
        return {
            p0: ['left_shoulder', 'right_shoulder'],
            p1: ['left_hip', 'right_hip'],
        };
    }
    if (part === 'right-upper-arm') {
        return {
            p0: 'right_shoulder',
            p1: 'right_elbow',
        };
    }
    if (part === 'right-lower-arm') {
        return {
            p0: 'right_elbow',
            p1: 'right_wrist',
        };
    }
    if (part === 'left-upper-arm') {
        return {
            p0: 'left_shoulder',
            p1: 'left_elbow',
        };
    }
    if (part === 'left-lower-arm') {
        return {
            p0: 'left_elbow',
            p1: 'left_wrist',
        };
    }
    if (part === 'right-upper-leg') {
        return {
            p0: 'right_hip',
            p1: 'right_knee',
        };
    }
    if (part === 'right-lower-leg') {
        return {
            p0: 'right_knee',
            p1: 'right_ankle',
        };
    }
    if (part === 'left-upper-leg') {
        return {
            p0: 'left_hip',
            p1: 'left_knee',
        };
    }
    if (part === 'left-lower-leg') {
        return {
            p0: 'left_knee',
            p1: 'left_ankle',
        };
    }
}
function midpoint(points, keys) {
    var p0 = points.find(function (el) { return el.name === keys[0]; });
    var p1 = points.find(function (el) { return el.name === keys[1]; });
    var v = new Vector3(p1.x, p1.y, p1.z);
    v.subtract(p0).scale(0.5);
    return {
        x: v.x,
        y: v.y,
        z: v.z,
        score: (p0.score + p1.score) / 2,
    };
}
export function translateKeys(part, points) {
    if (part === 'hip') {
        return {
            p0: [0, 0, 0],
            p1: [0, 0, 1],
        };
    }
    var keys = findKeys(part);
    var p0 = Array.isArray(keys.p0)
        ? midpoint(points, keys.p0)
        : points.find(function (el) { return el.name === keys.p0; });
    var p1 = Array.isArray(keys.p1)
        ? midpoint(points, keys.p1)
        : points.find(function (el) { return el.name === keys.p1; });
    return {
        p0: kptToZup(p0),
        p1: kptToZup(p1),
    };
}
//# sourceMappingURL=keypoints.js.map